import React, { useMemo } from "react";
import { useDataWithRoute } from "../utils/hooks";
import PieChart from "../components/PieChart";
import { Spinner } from "reactstrap";
import { VsiBubbleFavs } from "../styled/App.styled";
import { useVsiAppContext } from "../stores/VsiApp";
import { capitalizeWord } from "../utils/Helpers";

const allBus = [
  { value: "device", label: "Device" },
  { value: "device_type_code", label: "Device Type" },
  { value: "data_center", label: "Data Center" },
  { value: "classification", label: "Classification" }
];

export default function FreeSpaceByDevice({ params }) {
  const { client: { clientId }, getPeriodId } = useVsiAppContext();
  const periodId = getPeriodId("STORAGE");

  const defaultBu = useMemo(() => {
    const searchBu = params?.[0];
    return searchBu ? allBus.find(({ value }) => searchBu.value === value) : allBus[0];
  }, [params]);
  const { value: buValue } = defaultBu;

  const route = useMemo(() => `/api/v6/report/enterprise_free_space_by_${encodeURI(buValue)}_proc?client_id=${clientId}&period_id=${periodId}`, [clientId, periodId, buValue]);
  const [{ recordset }, { isLoading }] = useDataWithRoute(route);

  const pieData = useMemo(() => {
    const pieDict = {};
    const mungedData = [];

    (recordset || []).forEach(datum => {
      const filterName = buValue === "device" ? "device_name" : buValue;
      if (!pieDict[datum[filterName]]) {
        pieDict[datum[filterName]] = 0;
      }
      pieDict[datum[filterName]] += datum.total_free;
    });

    for (let key in pieDict) {
      mungedData.push({
        name: key,
        y: pieDict[key]
      });
    }

    return [
      {
        name: buValue || "Device",
        colorByPoint: true,
        data: mungedData
      }
    ];
  }, [recordset, buValue]);

  return isLoading ? (
    <Spinner color={"success"} />
  ) : (
    <VsiBubbleFavs>
      <PieChart
        height={420}
        title={`Free Space by ${capitalizeWord(buValue)}`}
        disableLabels={true}
        series={pieData}
        includeLegend={false}
      />
    </VsiBubbleFavs>
  );
}